import { useEffect, useMemo, useState } from "react";
import Carousel3D from "./ui/Carousel3D";
import CatalogFlipbook from "./CatalogFlipbook";

export default function Features() {
  const categories = useMemo(
    () => [
      {
        id: "destacados",
        label: "Tratamientos destacados",
        items: [
          {
            title: "BOTOX",
            button: "Cotizar ahora",
            desc:
              "Tratamiento seguro y muy versátil que relaja la musculatura para suavizar y/o prevenir arrugas dinámicas. Su aplicación avanzada permite trabajar no solo el tercio superior del rostro, sino también zonas como el tercio medio e inferior, además de tratar condiciones como la hiperhidrosis, bruxismo, acné, rosácea, exceso de sebo, queratosis pilaris, entre otros. Logrando resultados naturales, armónicos y personalizados.",
            src: "/img/TratamientoBotox.JPG",
            time: "30 min a 60 min",
          },
          {
            title: "Ácido Hialurónico",
            button: "Cotizar ahora",
            desc:
              "Tratamiento biocompatible que hidrata profundamente, restaura volúmenes y mejora la armonización facial. Su aplicación estratégica permite definir contornos, suavizar líneas y potenciar rasgos, logrando resultados naturales, equilibrados y personalizados.",
            src: "/img/TratamientoAcidohialuronico.jpeg",
            time: "45 min a 90 min",
          },
          {
            title: "Bioestimuladores de Colágeno",
            button: "Cotizar ahora",
            desc:
              "Tratamiento avanzado que activa la producción natural de colágeno, mejorando progresivamente la firmeza, calidad y estructura de la piel. Productos como Radiesse, Sculptra, Ellansé y Lanluma permiten restaurar volumen de forma sutil y lograr un rejuvenecimiento global con resultados naturales, duraderos y armónicos, según diagnóstico personalizado.",
            src: "/img/BIOESTIMULADORES.jpeg",
            time: "60 min a 75 min",
          },
          {
            title: "Hilos Tensores y Revitalizantes",
            button: "Cotizar ahora",
            desc:
              "Los hilos tensores son un tratamiento mínimamente invasivo que permite reposicionar y tensar los tejidos, mejorando la firmeza y definición del rostro, logrando un efecto lifting inmediato y también progresivo. Los hilos revitalizantes (lisos) estimulan colágeno para mejorar la calidad de la piel de forma progresiva. Ambos logran resultados naturales y armónicos.",
            src: "/img/Hilos_Tensores_y_Revitalizantes.jpeg",
            time: "45 min a 75 min",
          },
          {
            title: "Tratamiento para el Crecimiento Capilar",
            button: "Cotizar ahora",
            desc:
              "El tratamiento capilar con PRP, vitaminas y alta frecuencia estimula el folículo piloso, fortaleciendo el cabello y promoviendo un crecimiento más denso, mayor cantidad, saludable y progresivo. Sesiones según evaluación previa.",
            src: "/img/Tratamiento_para_el_Crecimiento_Capilar.jpeg",
            time: "60 min a 90 min",
          },
        ],
      },
      {
        id: "regenerativa",
        label: "Dermoestética regenerativa avanzada",
        items: [
          {
            title: "NAD+",
            button: "Cotizar ahora",
            desc:
              "Coenzima esencial que participa en la producción de energía celular a nivel mitocondrial.",
            src: "/img/NAD.jpg",
            time: "45 min a 60 min",
          },
          {
            title: "Exosomas",
            button: "Cotizar ahora",
            desc:
              "Estimulan la comunicación entre células y potencian los procesos de reparación de la piel. Mejoran textura, firmeza y luminosidad, ayudando a revertir signos de envejecimiento y daño cutáneo de forma profunda y progresiva.",
            src: "/img/Exosomas.WEBP",
            time: "45 min a 60 min",
          },
          {
            title: "ADN Salmón (PN/PDRN)",
            button: "Cotizar ahora",
            desc:
              "Estimula la reparación celular y mejora la calidad de la piel desde el interior. Favorece la hidratación, elasticidad y luminosidad, ayudando a revitalizar tejidos dañados y logrando una piel más firme, saludable y rejuvenecida.",
            src: "/img/ADNSALMON.jpg",
            time: "45 min a 60 min",
          },
        ],
      },
     
      {
        id: "piel",
        label: "Cuidado y calidad de la piel",
        items: [
          {
            title: "Limpieza Facial Profesional",
            button: "Cotizar ahora",
            desc:
              "Tratamiento esencial que, según las necesidades de la piel, permite purificar, equilibrar y mejorar su calidad, devolviendo luminosidad y vitalidad, además de prepararla para potenciar otros tratamientos. Contamos con 3 tipos según necesidad y profundidad.",
            src: "/img/TratamientoLimpiezafacial.JPG",
            time: "1 a 2 hrs",
          },
          {
            title: "Vitaminas Faciales",
            button: "Cotizar ahora",
            desc:
              "Tratamiento facial en base a vitaminas que nutren, iluminan, despigmentan o hidratan la piel en profundidad, empleadas con técnica de microneedling (dermapen) o mesoterapia, según evaluación. Incluye limpieza facial de preparación.",
            src: "/img/TratamietoVitaminasfaciales.png",
            time: "45 min a 60 min",
          },
        ],
      },
      {
        id: "bienestar",
        label: "Bienestar integral",
        items: [
          {
            title: "Terapia Ortomolecular",
            button: "Cotizar ahora",
            desc:
              "La sueroterapia es un tratamiento que aporta vitaminas y nutrientes esenciales de forma endovenosa directa para optimizar la función celular, mejorar la calidad de la piel y promover bienestar integral, logrando una apariencia más luminosa y revitalizada. Contamos con 8 tipos de sueros según necesidad.",
            src: "/img/Terapiaortomolecular.jpeg",
            time: "60 min a 90 min",
          },
        ],
      },
      {
        id: "avanzados",
        label: "Tratamientos estéticos avanzados facial y corporal",
        items: [
          {
            title: "Hilos Tensores y Revitalizantes",
            button: "Cotizar ahora",
            desc:
              "Los hilos tensores son un tratamiento mínimamente invasivo que permite reposicionar y tensar los tejidos, mejorando la firmeza y definición del rostro, logrando un efecto lifting inmediato y también progresivo. Los hilos revitalizantes (lisos) estimulan colágeno para mejorar la calidad de la piel de forma progresiva. Ambos logran resultados naturales y armónicos.",
            src: "/img/Hilos_Tensores_y_Revitalizantes.jpeg",
            time: "45 min a 75 min",
          },
          {
            title: "Enzimas Lipolíticas",
            button: "Cotizar ahora",
            desc:
              "Tratamiento premium que ayuda a reducir grasa localizada y mejorar el contorno facial y/o corporal de forma progresiva, logrando resultados visibles y objetivos. Sesiones según evaluación.",
            src: "/img/Enzimaslipoliticas.jpg",
            time: "40 min a 60 min",
          },
        ],
      },
      {
        id: "capilar",
        label: "Salud capilar",
        items: [
          {
            title: "Tratamiento para el Crecimiento Capilar",
            button: "Cotizar ahora",
            desc:
              "El tratamiento capilar con PRP, vitaminas y alta frecuencia estimula el folículo piloso, fortaleciendo el cabello y promoviendo un crecimiento más denso, mayor cantidad, saludable y progresivo. Sesiones según evaluación previa.",
            src: "/img/Tratamiento_para_el_Crecimiento_Capilar.jpeg",
            time: "60 min a 90 min",
          },
        ],
      },
    ],
    []
  );

  const [activeCategory, setActiveCategory] = useState(categories[0].id);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openCatalog, setOpenCatalog] = useState(false);

  const activeCategoryData =
    categories.find((cat) => cat.id === activeCategory) ?? categories[0];

  const slides = activeCategoryData.items;
  const active = slides[activeIndex] ?? slides[0];

  useEffect(() => {
    setActiveIndex(0);
  }, [activeCategory]);

  const whatsappUrl = active
    ? `https://wa.me/56920910798?text=${encodeURIComponent(
        `Hola! quiero cotizar el tratamiento "${active.title}".`
      )}`
    : "#";

  return (
    <>
      <section
        id="features"
        className="relative isolate overflow-hidden py-16 md:py-24 scroll-mt-24"
      >
        <div className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-[#80aba5]" />

          <div
            className="absolute inset-0 opacity-70"
            style={{
              background:
                "radial-gradient(1100px 650px at 18% 12%, rgba(255,255,255,.32), rgba(255,255,255,0) 60%), radial-gradient(900px 520px at 92% 20%, rgba(235,169,169,.20), rgba(235,169,169,0) 60%)",
            }}
          />

          <div
            className="absolute inset-0 opacity-45"
            style={{
              background:
                "radial-gradient(1200px 900px at 50% 35%, rgba(0,0,0,0), rgba(0,0,0,.12))",
            }}
          />

          <div className="absolute inset-x-0 bottom-0 h-[45%] bg-gradient-to-b from-transparent via-white/60 to-white" />
          <div className="absolute inset-0 opacity-[0.07] bg-noise" />
        </div>

        <style>{`
          .bg-noise{
            background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='140' height='140' filter='url(%23n)' opacity='.55'/%3E%3C/svg%3E");
            background-size:180px 180px;
          }

          .ios-card{
            position:relative;
            border-radius:28px;
            background:rgba(255,255,255,.72);
            backdrop-filter:blur(28px) saturate(150%);
            -webkit-backdrop-filter:blur(28px) saturate(150%);
            border:1px solid rgba(255,255,255,.65);
            box-shadow:0 30px 90px rgba(0,0,0,.16);
            overflow:hidden;
          }

          .ios-glow{
            pointer-events:none;
            position:absolute;
            top:-110px;
            left:50%;
            transform:translateX(-50%);
            width:560px;
            height:220px;
            border-radius:999px;
            opacity:.75;
            filter:blur(24px);
            background:radial-gradient(circle, rgba(255,255,255,.95), rgba(255,255,255,0) 70%);
          }

          .ios-inset{
            pointer-events:none;
            position:absolute;
            inset:0;
            border-radius:28px;
            box-shadow:inset 0 1px 0 rgba(255,255,255,.80), inset 0 -1px 0 rgba(0,0,0,.08);
          }

          .ios-pill{
            border-radius:999px;
            background:rgba(255,255,255,.8);
            border:1px solid rgba(128,171,165,.20);
            padding:8px 14px;
            font-size:12px;
            color:rgba(54,107,99,.95);
            box-shadow:inset 0 1px 0 rgba(255,255,255,.88);
            transition:all .2s ease;
          }

          .ios-pill-soft{
            background:rgba(128,171,165,.12);
            border-color:rgba(128,171,165,.20);
          }

          .category-chip{
            border-radius:999px;
            border:1px solid rgba(255,255,255,.45);
            background:rgba(255,255,255,.58);
            color:rgba(54,107,99,.95);
            padding:10px 14px;
            font-size:13px;
            font-weight:600;
            line-height:1.2;
            white-space:nowrap;
            box-shadow:0 10px 30px rgba(0,0,0,.06);
            transition:all .25s ease;
            cursor:pointer;
          }

          .category-chip:hover{
            background:rgba(255,255,255,.76);
            transform:translateY(-1px);
          }

          .category-chip.active{
            background:linear-gradient(135deg, rgba(54,107,99,1), rgba(128,171,165,1));
            color:#fff;
            border-color:transparent;
            box-shadow:0 16px 36px rgba(54,107,99,.26);
          }

          .ios-btn-primary{
            border-radius:999px;
            background:rgba(54,107,99,1);
            color:white;
            padding:10px 18px;
            font-size:14px;
            font-weight:600;
            box-shadow:0 14px 34px rgba(54,107,99,.28);
            transition:filter .2s ease, transform .2s ease;
            border:0;
            cursor:pointer;
            display:inline-flex;
            align-items:center;
            justify-content:center;
            text-decoration:none;
          }

          .ios-btn-primary:hover{
            filter:brightness(1.05);
            transform:translateY(-1px);
          }

          .ios-btn-ghost{
            border-radius:999px;
            background:rgba(255,255,255,.78);
            border:1px solid rgba(54,107,99,.14);
            color:rgba(54,107,99,1);
            padding:10px 18px;
            font-size:14px;
            font-weight:600;
            transition:background .2s ease, transform .2s ease;
            cursor:pointer;
          }

          .ios-btn-ghost:hover{
            background:rgba(255,255,255,.92);
            transform:translateY(-1px);
          }

          .feature-info-card{
            display:flex;
            flex-direction:column;
          }

          .feature-desc-scroll{
            color:rgba(0,0,0,.72);
            line-height:1.7;
            white-space:pre-line;
          }

          .category-row{
            display:flex;
            gap:10px;
            overflow:auto;
            padding-bottom:6px;
            scrollbar-width:none;
          }

          .category-row::-webkit-scrollbar{
            display:none;
          }

          @media (max-width: 767px){
            .feature-desc-scroll{
              max-height:210px;
              overflow:auto;
              padding-right:6px;
            }

            .feature-desc-scroll::-webkit-scrollbar{
              width:6px;
            }

            .feature-desc-scroll::-webkit-scrollbar-thumb{
              background:rgba(54,107,99,.25);
              border-radius:999px;
            }
          }

          @media (min-width: 1024px){
            .features-left-col{
              display:flex;
              flex-direction:column;
              justify-content:flex-start;
            }

            .feature-info-card{
              min-height:400px;
            }

            .feature-actions{
              margin-top:auto;
            }

            .carousel-shell{
              max-width:900px;
            }
          }
        `}</style>

        <div className="relative z-10 mx-auto max-w-7xl px-4">
          <div className="mx-auto mb-8 max-w-5xl text-center">
            <span className="ios-pill">Tratamientos por categoría</span>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-white md:text-5xl">
              Encuentra el tratamiento ideal para ti
            </h2>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-white/85 md:text-base">
              Nuestros tratamientos están ordenados en categorías para facilitar una navegación intuitiva y clara, mejorando tu experiencia desde cualquier dispositivo. Recuerda que tenemos muchos más, en el catálogo de servicios.
            </p>
          </div>

          <div className="ios-card mb-6 p-4 md:p-5">
            <div className="ios-glow" />
            <div className="ios-inset" />
            <div className="category-row">
              {categories.map((category) => (
                <button
                  key={category.id}
                  type="button"
                  className={`category-chip ${
                    activeCategory === category.id ? "active" : ""
                  }`}
                  onClick={() => setActiveCategory(category.id)}
                >
                  {category.label}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 items-start lg:grid-cols-12">
            <div className="features-left-col lg:col-span-5">
              <div className="ios-card">
                <div className="ios-glow" />
                <div className="ios-inset" />

                <div className="p-6 md:p-8">
                  <div className="mb-4">
                    <p className="text-[color:var(--c1)]/75 text-sm tracking-wide">
                      {activeCategoryData.label}
                    </p>
                    <h2 className="mt-2 text-2xl md:text-4xl font-semibold tracking-tight text-[color:var(--c1)]">
                      {active?.title}
                    </h2>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="ios-pill ios-pill-soft">
                      {slides.length} tratamiento{slides.length > 1 ? "s" : ""}
                    </span>
                  </div>
                </div>
              </div>

              <div className="ios-card feature-info-card mt-5 p-6 md:p-7">
                <div className="ios-glow" />
                <div className="ios-inset" />

                <div className="feature-desc-scroll">
                  <p className="text-[color:var(--ink)]/80 leading-relaxed">
                    {active?.desc}
                  </p>
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  {active?.time && (
                    <span className="ios-pill ios-pill-soft">
                      ⏱ {active.time}
                    </span>
                  )}
                </div>

                <div className="feature-actions mt-6 flex flex-wrap items-center gap-3">
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="ios-btn-primary"
                  >
                    Cotizar ahora
                  </a>

                  <button
                    className="ios-btn-ghost"
                    type="button"
                    onClick={() => setOpenCatalog(true)}
                  >
                    Ver catálogo completo
                  </button>
                </div>

                <div className="mt-6 h-px w-full bg-[color:var(--c2)]/20" />
                <p className="mt-4 text-xs text-[color:var(--muted)]">
                  * Los tratamientos se ajustan según evaluación clínica personalizada.
                </p>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="carousel-shell mx-auto max-w-[900px]">
                <div className="ios-card p-4 md:p-5">
                  <div className="ios-glow" />
                  <div className="ios-inset" />

                  <Carousel3D
                    slides={slides}
                    activeIndex={activeIndex}
                    onActiveChange={setActiveIndex}
                    size="lg"
                    showControls={slides.length > 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CatalogFlipbook
        open={openCatalog}
        onClose={() => setOpenCatalog(false)}
      />
    </>
  );
}